import { Empty, Modal, Spin } from 'antd'
import { usePointTransactions } from '@/entities/member'

type PointTransactionsModalProps = {
  open: boolean
  onClose: () => void
}

export function PointTransactionsModal({ open, onClose }: PointTransactionsModalProps) {
  const { data: transactions, isLoading } = usePointTransactions(1, 20)

  return <Modal open={open} title="积分流水" width={720} footer={null} onCancel={onClose}>
    {isLoading
      ? <div className="member-dialog-loading"><Spin /></div>
      : transactions?.items.length
        ? <div className="member-point-list">{transactions.items.map((item) => <div key={item.id}><span><b>{item.transactionTypeName}</b><small>{item.description || item.directionName}</small></span><strong className={item.direction === 'INCOME' ? 'is-income' : 'is-expense'}>{item.direction === 'INCOME' ? '+' : '-'}{Math.abs(item.changeAmount)}</strong><time>{new Date(item.createdAt).toLocaleString('zh-CN')}</time></div>)}</div>
        : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无积分流水" />}
  </Modal>
}
